"use strict";
import modalTemplate from "./entidades.agregar.html";
import modalController from "./entidades.agregar.controller";

class Entidades {
  constructor(NgTableParams, DataService, Message, Modal, $log, $scope) {
    "ngInject";
    //this.ValidationService = ValidationService;
    this.NgTableParams = NgTableParams;
    this.DataService = DataService;
    this.Message = Message;
    this.Modal = Modal;
    this.$log = $log;
    this.$scope = $scope;
    this.$scope.oneAtATime = true;
  }

  $onInit() {
    this.departamentos = [
      { nombre: "Chuquisaca" },
      { nombre: "La Paz" },
      { nombre: "Cochabamba" },
      { nombre: "Oruro" },
      { nombre: "Potosí" },
      { nombre: "Tarija" },
      { nombre: "Santa Cruz" },
      { nombre: "Beni" },
      { nombre: "Pando" },
    ];
    this.registros = [];
    this.$log.log("Inicializacion de entidades");
    this.obtenerRegistros();
  }

  obtenerRegistros() {
    this.$log.log("Ingreso a entidades cobro servicio");
    this.tableParams = new this.NgTableParams(
      {
        count: 10,
      },
      {
        getData: (params) => {
          let data = params.url();
          const { count, page } = data;
          const sort = this.getSorting(data);
          const query = {
            limit: count,
            page: page,
            departamento: this.departamento ? this.departamento.nombre : "",
            municipio: this.entidad ? this.entidad : "",
          };
          if (sort) {
            query.order = sort;
          }
          const resultado = this.DataService.list(
            "centralizador/dpa/listar",
            query
          ).then((response) => {
            if (response) {
              params.total(response.datos.count);
              this.renderLabels({
                ini: (page - 1) * count + 1,
                end:
                  page * count < response.datos.count
                    ? page * count
                    : response.datos.count,
                total: response.datos.count,
              });
              return response.datos.rows;
            }
          });
          this.$log.log(
            "Resultado>>>>>>>>>>>>>.. de obtencion de datos:",
            resultado
          );
          return resultado;
        },
      }
    );
  }

  getSorting(params) {
    for (let key in params) {
      if (key.indexOf("sorting") != -1) {
        return (
          (params[key] == "desc" ? "-" : "") +
          this.removeCorchete(key, "sorting")
        );
      }
    }
    return null;
  }

  renderLabels(params) {
    params;
  }

  modalAgregarEntidad() {
    this.Modal.show({
      template: modalTemplate,
      controller: modalController,
      size: "lg",
    });
  }
}
export default Entidades;



// WEBPACK FOOTER //
// ./src/app/components/entidades/entidades.controller.js